import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { useQueryClient } from '@tanstack/react-query';

type QueryHelper = {
  excludePeople: (candidateIds: number[]) => void;
  invalidatePeople: (options?: { refetch: boolean }) => void;
  invalidateCandidate: (id: number) => void;
};

const useQueryHelper = (): QueryHelper => {
  const { setValue } = useFormContext();
  const queryClient = useQueryClient();

  const excludePeople = (candidateIds: number[]) => {
    setValue('excludedIds', candidateIds);

    setTimeout(() => {
      queryClient.invalidateQueries({
        queryKey: ['people'],
      });
    }, 0);
  };

  const invalidatePeople = (options?: { refetch: boolean }) => {
    queryClient.invalidateQueries({
      queryKey: ['people'],
      refetchType: options?.refetch === false ? 'none' : 'active',
    });
  };

  const invalidateCandidate = (id: number) => {
    queryClient.invalidateQueries({
      queryKey: ['person', 'panel', id],
    });
  };

  return {
    excludePeople,
    invalidatePeople,
    invalidateCandidate,
  };
};

export default useQueryHelper;
